<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M0.570312 9.85707C0.570312 10.539 0.84123 11.1931 1.32347 11.6754C1.80571 12.1575 2.45975 12.4285 3.14174 12.4285C3.82372 12.4285 4.47778 12.1575 4.96002 11.6754C5.44224 11.1931 5.71317 10.539 5.71317 9.85707C5.71317 9.17513 5.44224 8.52107 4.96002 8.0388C4.47778 7.55656 3.82372 7.28564 3.14174 7.28564C2.45975 7.28564 1.80571 7.55656 1.32347 8.0388C0.84123 8.52107 0.570312 9.17513 0.570312 9.85707Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10.2852 9.85707C10.2852 10.539 10.5561 11.1931 11.0383 11.6754C11.5206 12.1575 12.1746 12.4285 12.8566 12.4285C13.5385 12.4285 14.1926 12.1575 14.6749 11.6754C15.157 11.1931 15.428 10.539 15.428 9.85707C15.428 9.17513 15.157 8.52107 14.6749 8.0388C14.1926 7.55656 13.5385 7.28564 12.8566 7.28564C12.1746 7.28564 11.5206 7.55656 11.0383 8.0388C10.5561 8.52107 10.2852 9.17513 10.2852 9.85707Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M7.99888 8.99993L4.57031 3.28564"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M5.66043 5.10107L3.14258 9.85707L7.99972 8.99993L11.2579 5.19867"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M12.8555 9.85701L10.2578 2.28906H13.2756"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M3.42773 3.28564H6.28488"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
